// extracted by mini-css-extract-plugin
module.exports = {"nounWrapper":"AuctionHero_nounWrapper__3bCAB","nounContentCol":"AuctionHero_nounContentCol__Wi8g-","auctionActivityCol":"AuctionHero_auctionActivityCol__3Crli"};